module.exports = __webpack_public_path__ + "img/Manuel-7.1fbde80a.jpg";